import { styled } from '@mui/material/styles';

export const IconToggleGroupContainer = styled('div')`
  display: inline-flex;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 3px;
`;

interface IconToggleButtonProps {
  $active?: boolean;
}

export const IconToggleButton = styled('button', {
  shouldForwardProp: prop => prop !== '$active',
})<IconToggleButtonProps>(({ $active }) => ({
  width: 38,
  height: 32,
  borderRadius: 5,
  border: 'none',
  background: $active ? '#E8F8EF' : 'transparent',
  color: $active ? '#16A35A' : '#8A93A6',
  display: 'grid',
  placeItems: 'center',
  cursor: 'pointer',
  transition: 'background-color 0.15s ease, color 0.15s ease',
  '&:hover': {
    background: $active ? '#E8F8EF' : 'rgba(194, 194, 194, 0.1)',
  },
  '& svg': {
    stroke: 'currentColor',
  },
}));
